export default "__VITE_ASSET__ClozvaWS__"